var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Other Projects")]),_c('div',{staticStyle:{"margin-bottom":"30px"}},[_vm._v(" Here are some other works I've wanted to share that are relevant to game development. ")]),_c('ProjectsList',{attrs:{"projects":_vm.projects}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }